'use strict';

exports.__esModule = true;
exports.default = undefined;

var _google_map = require('./google_map');

var _google_map2 = _interopRequireDefault(_google_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _google_map2.default;


//////////////////
// WEBPACK FOOTER
// ./~/google-map-react/lib/index.js
// module id = 335
// module chunks = 2